import React from 'react';
import { Link, mq } from '@kvdbil/components';
import styled from 'styled-components';
import { FooterNavigationData } from '~/App/shared/interfaces/store/CmsData';
import { Color, Size, Variant } from '@kvdbil/components/types/Types';
import { Path } from '@kvdbil/components/types/components/Link';

const Container = styled.ul`
  display: flex;
  gap: 1rem;
  padding: 1rem 0;

  & > * {
    flex: 1;
  }

  ${mq(null, 'tablet')} {
    display: none;
  }
`;

interface Props {
  buttons: FooterNavigationData['footerButtons'];
}

const Buttons = ({ buttons }: Props) => {
  return (
    <Container>
      {buttons?.map((button, index) => {
        if (button?.url && button?.text) {
          return (
            <li key={button?.url ?? index}>
              <Link
                isButton
                buttonColor={(button?.color as Color) || 'info'}
                buttonColorShade="dark"
                buttonSize={(button?.size as Size) || 'regular'}
                buttonVariant={(button?.variant as Variant) || 'solid'}
                fullWidth
                text={button?.text}
                path={button?.url as Path}
                target={button?.openLinkInNewWindow ? '_blank' : undefined}
              />
            </li>
          );
        }
      })}
    </Container>
  );
};

export default Buttons;
